import { Helmet } from 'react-helmet';
import { useState } from 'react';
import '../assets/styles/TrackShipmentPage.css';

function TrackShipmentPage() {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate tracking lookup
    setStatus('success');
  };

  return (
    <>
      <Helmet>
        <title>RFF Cargo: Track Shipment</title>
        <meta name="description" content="Track your shipment with RFF Cargo using your tracking number." />
      </Helmet>
      <section className="track-shipment-section py-5">
        <div className="container">
          <h2 className="track-title fw-bold mb-4">Track Your Shipment</h2>
          <p className="track-description">
            Enter your tracking number below to get the latest updates on your shipment.
          </p>
          {status === 'success' && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              Shipment found! Your package is in transit.
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}
          <form onSubmit={handleSubmit} className="track-form">
            <div className="mb-3">
              <label htmlFor="trackingNumber" className="form-label">Tracking Number</label>
              <input
                type="text"
                className="form-control"
                id="trackingNumber"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                required
                aria-required="true"
              />
            </div>
            <button type="submit" className="btn btn-track-shipment">Track Shipment</button>
          </form>
        </div>
      </section>
    </>
  );
}

export default TrackShipmentPage;